import { Pipe, PipeTransform } from '@angular/core';
import { BillingAccount } from '../models/subscriptions/billing-account.model';
import { Contact } from '../models/subscriptions/contact.model';

@Pipe({
  name: 'flyAccountDisplay'
})
export class AccountDisplayPipe implements PipeTransform {
  transform(value: BillingAccount): string {
    if (value.subscriberInfo != null) {
      const display = this.generateDisplayFromContact(value.subscriberInfo, value.billingAccountId);
      if (display != null) {
        return display;
      }
    }

    if (value.billingInfo != null) {
      const display = this.generateDisplayFromContact(value.billingInfo, value.billingAccountId);
      if (display != null) {
        return display;
      }
    }

    return value.billingAccountId;
  }

  private generateDisplayFromContact(contact: Contact, billingAccountId: string): string | null {
    const companyAvailable = contact.company != null && contact.company.length > 0;
    const nameAvailable =
      contact.firstName != null &&
      contact.firstName.length > 0 &&
      contact.lastName != null &&
      contact.lastName.length > 0;
    if (companyAvailable) {
      return `${contact.company} - ${billingAccountId}`;
    } else if (nameAvailable) {
      return `${`${contact.firstName} ${contact.lastName}`} - ${billingAccountId}`;
    } else {
      return null;
    }
  }
}
